import React, { useState } from 'react'

// redux
import { connect } from "react-redux";

// stripe
import {
    CardElement,
    useElements,
    useStripe,

    CardNumberElement,
    CardExpiryElement,
    CardCvcElement
} from '@stripe/react-stripe-js';

function PaymentContainer(props) {
    // props
    const {
        cartDetails,

        setStripeToken,

        submitBtnRef
    } = props

    // consts
    const elements = useElements()
    const stripe = useStripe()
    const buttonStyles = {}

    // states
    const [buttonLoading, setButtonLoading] = useState(false)
    const [buttonDisable, setButtonDisable] = useState(false)

    const [errorMessage, setErrorMessage] = useState(false)

    // on form submit
    const handleFormSubmit = async ev => {
        ev.preventDefault()

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setErrorMessage("") // emptying error message
        
        // button loading and disabling
        setButtonLoading(true)
        setButtonDisable(true)

        const card = elements.getElement(CardNumberElement);
        const result = await stripe.createToken(card);

        if (result.error) {
            setErrorMessage(result.error.message) // setting error message

            // button loading and disabling
            setButtonLoading(false)
            setButtonDisable(false)
        } else {
            setErrorMessage("") // emptying error message

            setStripeToken(result.token.id)

            // button loading and disabling
            setButtonLoading(false)
            setButtonDisable(false)

            submitBtnRef.current.click() // submitting the form
        }
    }

    return (
        <React.Fragment>
            <form onSubmit={handleFormSubmit}>
                <div className="form-main d-flex flex-wrap">
                    <div className="st-form w-100">
                        <label>Card Number</label>
                        <CardNumberElement />
                    </div>

                    <div className="st-form exp-field">
                        <label>Expiry Date</label>
                        <CardExpiryElement />
                    </div>
                    <div className="st-form cvv-field">
                        <label>CVV</label>
                        <CardCvcElement />
                    </div>
                </div>

                {
                    errorMessage?.length ? (
                        <p className="text-danger st-fw-600 mb-0">{errorMessage}</p>
                    ) : null
                }

                {/* submit button */}
                <div className="btns w-100 pt-3">
                    <button
                        type="submit"
                        className="btn"
                        disabled={(!stripe) || (!elements) || buttonDisable}
                        style={buttonStyles}
                        onClick={handleFormSubmit}
                    >
                        {
                            buttonLoading ? (
                                "Loading..."
                            ) : (
                                <React.Fragment>
                                    Pay {cartDetails?.cart_total ?? 0}
                                </React.Fragment>
                            )
                        }
                    </button>
                </div>
            </form>

        </React.Fragment>
    )
}

const getDataFromStore = (state) => {
    return {
        cartDetails: state.cart.cartDetails,
    };
};

export default connect(getDataFromStore, null)(PaymentContainer);